let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("15ucL")).then(() => parcelRequire('3BhTj'));